import { t } from "@repo/translation";
import { FilterCheckbox } from "@repo/ui";
import { isChecked } from "@repo/utils";

import { FilterListContainer } from "./FilterListContainer";
import { type FilterItemsProps } from "./type";

export const OrderStatusFilter = ({ actions, filters }: FilterItemsProps) => (
  <FilterListContainer id="order-status-filter">
    <FilterCheckbox
      id="unblocked"
      value="unblocked"
      label={t("order_status.unblocked")}
      checked={isChecked(filters.orderStatus, "unblocked")}
      onCheckFilter={actions.setOrderStatus}
    />
    <FilterCheckbox
      id="created"
      value="created"
      label={t("order_status.created")}
      checked={isChecked(filters.orderStatus, "created")}
      onCheckFilter={actions.setOrderStatus}
    />
    <FilterCheckbox
      id="completed"
      value="completed"
      label={t("order_status.completed")}
      checked={isChecked(filters.orderStatus, "completed")}
      onCheckFilter={actions.setOrderStatus}
    />
    <FilterCheckbox
      id="cancelled"
      value="cancelled"
      label={t("order_status.cancelled")}
      checked={isChecked(filters.orderStatus, "cancelled")}
      onCheckFilter={actions.setOrderStatus}
    />
  </FilterListContainer>
);
